import { useEffect, useState } from "react";
import { internalApi } from "../../api/internal";
import api from "../../auth/api"; // ajusta

export default function LinkLeadContactModal({ open, onClose, thread, canManage, onSaved }) {
  const [mode, setMode] = useState("general"); // general|lead|contact
  const [leadId, setLeadId] = useState("");
  const [contactId, setContactId] = useState("");

  useEffect(() => {
    if (!open || !thread) return;
    if (thread.lead_id) { setMode("lead"); setLeadId(String(thread.lead_id)); setContactId(""); }
    else if (thread.contact_id) { setMode("contact"); setContactId(String(thread.contact_id)); setLeadId(""); }
    else { setMode("general"); setLeadId(""); setContactId(""); }
  }, [open, thread]);

  if (!open) return null;

  const save = async () => {
    if (!canManage) return;

    let payload = {};
    if (mode === "general") payload = { lead_id: null, contact_id: null };
    if (mode === "lead") {
      if (!leadId) return alert("Ingresa lead_id");
      payload = { lead_id: Number(leadId), contact_id: null };
    }
    if (mode === "contact") {
      if (!contactId) return alert("Ingresa contact_id");
      payload = { lead_id: null, contact_id: Number(contactId) };
    }

    try {
      const { data } = await internalApi.patchThread(thread.id, payload);
      onSaved?.(data?.thread || null);
      onClose();
    } catch (e) {
      alert(e?.response?.data?.error || "No se pudo vincular");
    }
  };

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center p-4 z-50">
      <div className="w-full max-w-lg bg-white rounded-xl border border-slate-200 overflow-hidden">
        <div className="p-4 border-b flex items-center justify-between">
          <div className="font-semibold">Vincular conversación</div>
          <button className="px-3 py-1.5 rounded-lg border" onClick={onClose}>Cerrar</button>
        </div>

        <div className="p-4 space-y-3">
          <div className="text-sm text-slate-600">
            Solo puede estar vinculada a <b>un lead</b> o <b>un contacto</b> (o quedar general).
          </div>

          <div className="flex gap-2">
            {["general", "lead", "contact"].map((k) => (
              <button
                key={k}
                className={`px-3 py-2 rounded-lg border text-sm ${
                  mode === k ? "border-slate-900" : "border-slate-200"
                }`}
                onClick={() => setMode(k)}
              >
                {k}
              </button>
            ))}
          </div>

          {mode === "lead" ? (
            <input
              className="w-full px-3 py-2 rounded-lg border text-sm"
              placeholder="lead_id (ej: 123)"
              value={leadId}
              onChange={(e) => setLeadId(e.target.value.replace(/\D/g, ""))}
            />
          ) : null}

          {mode === "contact" ? (
            <input
              className="w-full px-3 py-2 rounded-lg border text-sm"
              placeholder="contact_id (ej: 55)"
              value={contactId}
              onChange={(e) => setContactId(e.target.value.replace(/\D/g, ""))}
            />
          ) : null}

          <button
            className={`w-full px-3 py-2 rounded-lg text-sm ${
              canManage ? "bg-slate-900 text-white" : "bg-slate-200 text-slate-400"
            }`}
            disabled={!canManage}
            onClick={save}
          >
            Guardar
          </button>
        </div>
      </div>
    </div>
  );
}
